var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "FadeGroupTransition",
    [
      _vm.$route.name != null
        ? _c("router-view", { key: "view" })
        : _c("ScreenLoader", { key: "loader" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }